<template>
  <div
    class="mk-autoweb-image-video-text"
    :style="{
      'background':'url('+ element.commonStyle.backgroundImage +') #fff no-repeat center center'
    }"
  >
    <div class="w1200 animate_top">
      <div class="mk-autoweb-module-title">{{ element.titleBarName }}</div>
      <div class="mk-autoweb-image-video-text-nav">
        <ul class="mk-autoweb-image-video-text-nav-${element.uuid}">
          <li
            v-for="(item, index) in childItem.propsValue.data"
            :class="index == 0 ? 'pr open' : 'pr'"
            :key="index"
          >{{item.customField1}}</li>
        </ul>
      </div>
      <div :class="className()">
        <div class="mk-autoweb-image-video-text-content-text">
          <h4>{{ childItem.propsValue.data[0].customField1 }}</h4>
          <p>{{ childItem.propsValue.data[0].customField2 }}</p>
          <a
            class="mk-subject-btn mk-ldy-btn"
            href="javascript:;"
          >{{ childItem.propsValue.buttonInfo ? childItem.propsValue.buttonInfo.text : childItem.propsValue.data[0].customField4.text }}</a>
        </div>
        <div class="mk-autoweb-image-video-text-content-img">
          <img
            :src="isString(childItem.propsValue.data[0].customField3) ? childItem.propsValue.data[0].customField3 : childItem.propsValue.data[0].customField3.contentImage | imgUrl"
            alt
          />
          <img
            v-if="!isString(childItem.propsValue.data[0].customField3) && childItem.propsValue.data[0].customField3.contentType == 'video'"
            class="video-block-play"
            src="https://mks.yybip.com/group1/M00/01/F7/CgoRDGSAPjeATLhuAAAHsdousik151.png"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  buttonObject,
  contentObject
} from "@/modules/autoweb/config/elementObject.js";
import { mapState, mapMutations } from "vuex";
export default {
  name: "MkYingyongchangjing2Web",
  props: {
    element: {
      type: Object,
      default: () => {
        return {};
      }
    },
    childItem: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  methods: {
    isString(value) {
      if (Object.prototype.toString.call(value) === "[object String]") {
        return true;
      } else {
        return false;
      }
    },
    className() {
      let elementClass = "";
      let selectClass = _.filter(this.element.class, item => item.selected)[0];
      if (selectClass) {
        elementClass = selectClass.value;
      }
      let className = "mk-autoweb-image-video-text-content ";
      if (elementClass) {
        if (elementClass == "image-up-text-down") {
          className += "mk-autoweb-image-video-text-content-bottom";
        } else if (elementClass == "image-down-text-up") {
          className += "mk-autoweb-image-video-text-content-top";
        } else if (elementClass == "image-text-left-right") {
          className += "mk-autoweb-image-video-text-content-left";
        }
      } else {
        className += "mk-autoweb-image-video-text-content-left";
      }
      return className;
    },
    ...mapMutations(["setProjectData"]),
    // 升级组件属性方法
    updatePropsValue() {
      let updateFlag = false;
      this.projectData.elements = _.map(this.projectData.elements, el => {
        // 找到落地页当前组件
        if (el.uuid == this.element.uuid) {
          updateFlag = true;
          el.childNode = _.map(el.childNode, child => {
            let childDataTemp = _.cloneDeep(child.propsValue.data);
            child.propsValue.fields = this.fields;
            child.propsValue.data = {
              customField1: childDataTemp.customField1,
              customField11: childDataTemp.customField1, // 将原标题值赋予副标题
              customField2: childDataTemp.customField2,
              customField3: childDataTemp.customField3,
              customField4: childDataTemp.customField4
            };
            return child;
          });
          return el;
        } else {
          return el;
        }
      });
      updateFlag ? this.setProjectData(this.projectData) : "";
    }
  },
  data() {
    return {
      fields: [
        {
          code: "customField1",
          label: "标题",
          type: "text"
        },
        {
          code: "customField11",
          label: "副标题",
          type: "text"
        },
        {
          code: "customField2",
          label: "描述",
          type: "text"
        },
        {
          code: "customField3",
          label: "素材",
          type: "content",
          contentType: "image,video",
          defaultType: "image",
          width: 1000,
          height: 600,
          isMultiple: false
        },
        {
          code: "customField4",
          label: "按钮",
          type: "button"
        }
      ],
      data: [
        {
          customField1: "标题1",
          customField11: "副标题1",
          customField2: "在此输入描述说明信息...",
          customField3: _.cloneDeep(contentObject),
          customField4: _.cloneDeep(buttonObject)
        },
        {
          customField1: "标题2",
          customField11: "副标题2",
          customField2: "在此输入描述说明信息...",
          customField3: _.cloneDeep(contentObject),
          customField4: _.cloneDeep(buttonObject)
        },
        {
          customField1: "标题3",
          customField11: "副标题3",
          customField2: "在此输入描述说明信息...",
          customField3: _.cloneDeep(contentObject),
          customField4: _.cloneDeep(buttonObject)
        },
        {
          customField1: "标题4",
          customField11: "副标题4",
          customField2: "在此输入描述说明信息...",
          customField3: _.cloneDeep(contentObject),
          customField4: _.cloneDeep(buttonObject)
        }
      ]
    };
  },
  computed: {
    ...mapState({
      projectData: state => state.autowebStore.projectData
    })
  },
  mounted() {
    // 第一版本对象属性跟第二版本不一样，升级组件属性
    if (
      this.element &&
      this.element.childNode &&
      this.element.childNode.length > 0 &&
      _.filter(
        this.element.childNode[0].propsValue.fields,
        (f, fi) => f.code == "customField11"
      ).length == 0
    ) {
      // this.updatePropsValue();
    }
  }
};
</script>


<style lang="scss">
.mk-autoweb-module-title {
  font-size: 30px;
  line-height: 30px;
  text-align: center;
  letter-spacing: 2px;
  color: #e31924;
  padding-top: 40px;
  font-weight: bold;
  padding-bottom: 20px;
}
.pr {
  position: relative;
  margin: 0 auto;
  display: block;
}
.mk-autoweb-image-video-text {
  background-size: 100% 100% !important;
  min-height: 300px;
  padding: 0 20px;
}
.mk-autoweb-image-video-text-nav {
  border-bottom: 1px solid #979797;
  margin-top: 36px;
}
.mk-autoweb-image-video-text-nav ul {
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  align-items: center;
}
.mk-autoweb-image-video-text-nav li {
  font-weight: normal;
  font-size: 16px;
  text-align: center;
  color: #707070;
  line-height: 2;
  padding-bottom: 18px;
  cursor: pointer;
  transition: all 0.3s !important;
}
.mk-autoweb-image-video-text-nav li.open {
  color: #f8000c;
}
.mk-autoweb-image-video-text-nav li::after {
  display: block;
  height: 4px;
  position: absolute;
  top: auto;
  bottom: 0;
  background: transparent;
  border-radius: 2px;
  width: 100%;
  transition: all 0.3s !important;
  left: 0;
}
.mk-autoweb-image-video-text-nav li.open::after {
  background: #f8000c;
}
.mk-autoweb-image-video-text-content {
  padding: 20px 0;
  position: relative;
}

.mk-autoweb-image-video-text-content h4 {
  margin-bottom: 15px;
  font-size: 26px;
  font-weight: bolder;
}
.mk-autoweb-image-video-text-content p {
  margin-bottom: 30px;
  font-size: 16px;
  line-height: 1.5;
}
.mk-autoweb-image-video-text-content .mk-autoweb-image-video-text-content-img {
  height: 100%;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}
.mk-autoweb-image-video-text-content
  .mk-autoweb-image-video-text-content-img
  img {
  max-width: 100%;
}
.mk-autoweb-image-video-text-content
  .mk-autoweb-image-video-text-content-img
  .video-player {
  display: none;
}
.mk-autoweb-image-video-text-content
  .mk-autoweb-image-video-text-content-img
  .video-block-play {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 50px;
  height: 50px;
  cursor: pointer;
}
.mk-autoweb-image-video-text-content .mk-ldy-btn {
  margin: 0;
}
.mk-autoweb-image-video-text-content h4:empty,
.mk-autoweb-image-video-text-content p:empty {
  margin-bottom: 0;
}

.mk-autoweb-image-video-text-content-left,
.mk-autoweb-image-video-text-content-right {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.mk-autoweb-image-video-text-content-right {
  flex-flow: row-reverse;
}
.mk-autoweb-image-video-text-content-left p,
.mk-autoweb-image-video-text-content-right p {
  width: 410px;
}
.mk-autoweb-image-video-text-content-left
  .mk-autoweb-image-video-text-content-img,
.mk-autoweb-image-video-text-content-right
  .mk-autoweb-image-video-text-content-img {
  width: 760px;
}

.mk-autoweb-image-video-text-content-top h4,
.mk-autoweb-image-video-text-content-bottom h4 {
  display: none;
}
.mk-autoweb-image-video-text-content-top
  .mk-autoweb-image-video-text-content-text,
.mk-autoweb-image-video-text-content-bottom
  .mk-autoweb-image-video-text-content-text {
  text-align: center;
}
.mk-autoweb-image-video-text-content-top
  .mk-autoweb-image-video-text-content-img {
  margin-bottom: 150px;
}
.mk-autoweb-image-video-text-content-top .mk-ldy-btn {
  position: absolute;
  bottom: 50px;
  left: 50%;
  margin-left: -120px;
}
.mk-autoweb-image-video-text-content-bottom
  .mk-autoweb-image-video-text-content-img {
  margin-bottom: 250px;
}

.mk-autoweb-image-video-text-content-bottom
  .mk-autoweb-image-video-text-content-text {
  position: absolute;
  bottom: 50px;
  width: 100%;
}
.mk-autoweb-image-video-text-content-bottom .mk-ldy-btn {
  margin: 0 auto;
}
</style>
